module.exports = __webpack_public_path__ + "img/abo7.a730e1a3.jpg";